import { render, staticRenderFns } from "./BaseReleaseEvent.vue?vue&type=template&id=5cdcd9f4&scoped=true&"
import script from "./BaseReleaseEvent.vue?vue&type=script&lang=js&"
export * from "./BaseReleaseEvent.vue?vue&type=script&lang=js&"
import style0 from "./BaseReleaseEvent.vue?vue&type=style&index=0&id=5cdcd9f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdcd9f4",
  null
  
)

export default component.exports